module.exports = require('../../es/array/includes');



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/features/array/includes.js
// module id = 96
// module chunks = 0